
export class NumberStringHelper {
    constructor() {
    }

    public static groupString(number: number, getTextById: Function): string {
        var leftSideString: string = number.toString().substring((number.toString().charAt(0) == "-") ? 1 : 0, (number.toString().indexOf(".") == -1) ? Number.MAX_VALUE : number.toString().indexOf("."));

        var groupAmount: number = Math.floor(leftSideString.length / 3);
        var result: string = "";

        for (var i: number = 0; i < groupAmount; i++) {
            result = leftSideString.substr(leftSideString.length - 3, 3) + result;
            leftSideString = leftSideString.substr(0, leftSideString.length - 3);
            if (leftSideString.length > 0)
                result = getTextById("generic_decimalseparator") + result;
        }

        var rightSideString: string = (number.toString().indexOf(".") == -1) ? "" : getTextById("generic_comma") + number.toString().substr(number.toString().indexOf(".") + 1);

        result = ((number < 0) ? "-" : "") + leftSideString + result + rightSideString;
        return result;
    }
}
